var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79528 0.755307C6.37522 1.0446 6.30712 1.57226 6.64316 1.93388L11.3512 7.0001L6.64316 12.0663C6.30712 12.4279 6.37522 12.9556 6.79528 13.2449C7.21534 13.5342 7.82828 13.4756 8.16433 13.1139L13.3591 7.52391C13.6437 7.21768 13.6437 6.78253 13.3591 6.47629L8.16433 0.886259C7.82828 0.524644 7.21534 0.466014 6.79528 0.755307Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.420429 0.755307C-0.0626375 1.0446 -0.140958 1.57226 0.245495 1.93388L5.6597 7.0001L0.245496 12.0663C-0.140958 12.4279 -0.062637 12.9556 0.42043 13.2449C0.903497 13.5342 1.60838 13.4756 1.99484 13.1139L7.96883 7.52391C8.2961 7.21768 8.2961 6.78253 7.96883 6.47629L1.99484 0.886259C1.60838 0.524644 0.903496 0.466014 0.420429 0.755307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggle-icon.baaa0d90d48efae80f7a8d3193c7ddfc.svg";
export { ForwardRef as ReactComponent };